import { render } from "./Frames.vue?vue&type=template&id=cefa4424&ts=true"
import script from "./Frames.vue?vue&type=script&lang=ts"
export * from "./Frames.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__